import { lazy } from 'react';

import { Loadable } from '../../../utils';

export const Login = Loadable(lazy(() => import('../components/login/Login')));
export const ResetPassword = Loadable(lazy(() => import('../components/reset-password/ResetPassword')));
export const NewPassword = Loadable(lazy(() => import('../components/new-password/NewPassword')));
export const Logout = Loadable(lazy(() => import('../components/logout/Logout')));
